import { Component, OnInit, Input } from '@angular/core';
import { BreadcrumbService } from '../services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  // Array Input
  @Input() public pageName: string;
  @Input() public isTopLevel: boolean;

  constructor(private breadcrumbService: BreadcrumbService) { }

  async ngOnInit() {
    if (this.isTopLevel == true) {
      this.breadcrumbService.breadcrumbArray = [this.pageName]
    } else {
      this.breadcrumbService.breadcrumbArray.push(this.pageName)
    }
  }
}
